// src/admin/analytics/AnalyticsDownloadPopup.js
import React from "react";
import Popup from "reactjs-popup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TIMEZONE = "Asia/Kolkata";
const unitOptions = [
  { value: "days",   label: "Days"   },
  { value: "months", label: "Months" }
];

export default class AnalyticsDownloadPopup extends React.Component {
  state = {
    startDate:  new Date(),
    endDate:    new Date(),
    mode:       "once",       // "once" | "scheduled"
    scopeMode:  "relative",   // "relative" | "fixed"
    scopeValue: 1,
    scopeUnit:  "days",       // "days" | "months"
    freqValue:  1,
    freqUnit:   "months",       // "days" | "months"
    emailsInput:""            // comma-separated
  };

  closeModal = () => {
    this.props.onChange(false);
  };

  exportData = () => {
    const {
      startDate, endDate,
      mode, scopeMode, scopeValue, scopeUnit,
      freqValue, freqUnit, emailsInput
    } = this.state;

    // parse recipients
    const emails = emailsInput.split(",").map(s=>s.trim()).filter(Boolean);

    // build common args
    const args = { startDate, endDate };

    // build scheduleConfig
    const scheduleConfig = {
      timezone: TIMEZONE,
      mode,
    };

    if (mode === "once") {
      // nothing else needed
    } else {
      // scheduled
      if (!emails.length) return toast.error("Enter at least one email");
      if (freqValue < 1)  return toast.error("Frequency must be ≥ 1");
      if (scopeMode==="relative" && scopeValue<1) return toast.error("Scope must be ≥ 1");
      if (scopeMode==="fixed" && startDate> endDate) return toast.error("Invalid date range");

      scheduleConfig.emails     = emails;
      scheduleConfig.freqValue  = freqValue;
      scheduleConfig.freqUnit   = freqUnit;
      scheduleConfig.scopeMode  = scopeMode;

      if (scopeMode==="relative") {
        scheduleConfig.scopeValue = scopeValue;
        scheduleConfig.scopeUnit  = scopeUnit;
      } else {
        scheduleConfig.from = startDate.toISOString().slice(0,10);
        scheduleConfig.to   = endDate  .toISOString().slice(0,10);
      }
    }

    // invoke parent callback
    this.props.onExportJobStart(args, scheduleConfig);
    this.closeModal();
  };

  render() {
    const { openInfoPopup } = this.props;
    const {
      startDate, endDate, mode,
      scopeMode, scopeValue, scopeUnit,
      freqValue, freqUnit, emailsInput
    } = this.state;

    return (
      <div>
        <Popup open={openInfoPopup.open} onClose={this.closeModal} closeOnDocumentClick>
          <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
               <h2 className="mb-0">Download Analytics Report</h2>
               <a
                 className="card-options-remove"
                 onClick={this.closeModal}
                 style={{ cursor: 'pointer' }}
               >
                 <i className="fe fe-x" />
               </a>
             </div>
            <div className="card-body">

              {/* Mode */}
              <div className="form-group">
                <label>Mode</label><br/>
                <label className="mr-3">
                  <input
                    type="radio" checked={mode==="once"}
                    onChange={()=>this.setState({mode:"once"})}
                  /> One-Time
                </label>
                <label>
                  <input
                    type="radio" checked={mode==="scheduled"}
                    onChange={()=>this.setState({mode:"scheduled", scopeMode:"relative"})}
                  /> Scheduled
                </label>
              </div>

              {/* Dates */}
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>From</label>
                  <DatePicker
                    className="form-control ml-2"
                    selected={startDate}
                    onChange={d=>this.setState({startDate:d})}
                    maxDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    disabled={mode==="scheduled" && scopeMode==="relative"}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>To</label>
                  <DatePicker
                    className="form-control ml-2"
                    selected={endDate}
                    onChange={d=>this.setState({endDate:d})}
                    minDate={startDate}
                    dateFormat="dd/MM/yyyy"
                    disabled={mode==="scheduled" && scopeMode==="relative"}
                  />
                </div>
              </div>

              {/* Scheduled only */}
              {mode==="scheduled" && (
                <>
                  {/* Scope */}
                  <div className="form-group">
                    <label>Scope</label><br/>
                    <label className="mr-3">
                      <input
                        type="radio"
                        checked={scopeMode==="relative"}
                        onChange={()=>this.setState({scopeMode:"relative"})}
                      /> Last N
                    </label>
                    <label>
                      <input
                        type="radio"
                        checked={scopeMode==="fixed"}
                        onChange={()=>this.setState({scopeMode:"fixed"})}
                      /> Fixed Range
                    </label>
                  </div>

                  {scopeMode==="relative" ? (
                    <div className="form-row align-items-end">
                      <div className="form-group col-auto">
                        <label>N</label>
                        <input
                        type="number"
                        min="1"
                        className="form-control"
                        style={{ width: 80 }}
                        value={scopeValue}
                        onChange={e => {
                          const v = e.target.value
                          this.setState({
                            scopeValue: v === "" ? "" : parseInt(v, 10)
                          })
                        }}
                      />
                      </div>
                      <div className="form-group col">
                        <Select
                          options={unitOptions}
                          value={unitOptions.find(u=>u.value===scopeUnit)}
                          onChange={opt=>this.setState({scopeUnit:opt.value})}
                        />
                      </div>
                    </div>
                  ) : null}

                  {/* Frequency */}
                  <div className="form-row align-items-end">
                    <div className="form-group col-auto">
                      <label>Every</label>
                      <input
                      type="number"
                      min="1"
                      className="form-control"
                      style={{ width: 80 }}
                      value={freqValue}
                      onChange={e => {
                        const val = e.target.value;
                        this.setState({
                          freqValue: val === "" ? "" : parseInt(val, 10)
                        });
                      }}
                    />
                    </div>
                    <div className="form-group col">
                      <Select
                        options={unitOptions}
                        value={unitOptions.find(u=>u.value===freqUnit)}
                        onChange={opt=>this.setState({freqUnit:opt.value})}
                      />
                    </div>
                  </div>

                  {/* Recipients */}
                  <div className="form-group">
                    <label>Recipients</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="a@x.com, b@y.com"
                      value={emailsInput}
                      onChange={e=>this.setState({emailsInput:e.target.value})}
                    />
                  </div>
                </>
              )}

              {/* Submit */}
              <div className="form-group">
                <button
                  className="btn btn-primary btn-block"
                  onClick={this.exportData}
                >
                  {mode==="once" ? "Request Download" : "Schedule Report"}
                </button>
              </div>
            </div>
          </div>
        </Popup>
        <ToastContainer autoClose={3000} position="bottom-right"/>
      </div>
    );
  }
}
